
import React from 'react'
export const FormField: React.FC<{label:string; hint?:string; children:React.ReactNode}> = ({label, hint, children}) => (
  <label className="block my-2">
    <span className="text-sm font-medium">{label}</span>
    <div className="mt-1">{children}</div>
    {hint && <p className="text-xs text-gray-500 mt-1">{hint}</p>}
  </label>
)
